import { useState, useEffect } from 'react';
import { getPostsForSite } from '../../lib/directus';

export const useTags = (domain: string) => {
  const [tags, setTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true);
        const posts = await getPostsForSite(domain);
        const tagSet = new Set<string>();
        if (Array.isArray(posts)) {
          posts.forEach((post: any) => {
            if (post.tags && Array.isArray(post.tags)) {
              post.tags.forEach((tag: string) => {
                if (tag && typeof tag === 'string') tagSet.add(tag);
              });
            }
          });
        }
        setTags(Array.from(tagSet).sort());
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки тегов:', err);
        setError('Не удалось загрузить теги');
      } finally {
        setLoading(false);
      }
    };
    fetchTags();
  }, [domain]);

  return { tags, loading, error };
};